var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-4 pa-sm-8",attrs:{"fluid":""}},[_c('h2',{staticClass:"dark--text text-h6 font-weight-bold mt-8"},[_vm._v("Tutorials")]),_c('app-tutorial-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }